import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { open_api_with_cookies } from "../../Utils/network";
import LoadingOverlay from "../../Components/Dialog/LoadingOverlay";

const TokenLoginPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") || "/dashboard";
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loginViaToken = async () => {
      if (!token) {
        console.error("No token provided");
        navigate("/login?error=missing_token");
        return;
      }

      try {
        setIsLoading(true);

        const response = await open_api_with_cookies.get(
          `auth/token-login/${token}/`,
          {
            params: { next },
          }
        );

        if (response.status === 200) {
          // Check if the response indicates a redirect
          if (response.data?.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else {
            // Fallback: manually navigate to the next page
            navigate(next);
          }
        } else {
          console.error("Token login failed:", response.data);
          navigate("/login?error=expired_or_invalid");
        }
      } catch (error) {
        console.error("Token login failed:", error);

        // Handle specific error cases
        if (error.response?.status === 401) {
          navigate("/login?error=expired_or_invalid");
        } else if (error.response?.status === 404) {
          navigate("/login?error=invalid_token");
        } else {
          navigate("/login?error=network");
        }
      } finally {
        setIsLoading(false);
      }
    };

    loginViaToken();
  }, [token, next, navigate]);

  if (isLoading) {
    return <LoadingOverlay message="Logging you in..." />;
  }

  // This should rarely be seen as we navigate away or show loading
  return (
    <div
      style={{
        padding: "100px",
        textAlign: "center",
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2>Processing login...</h2>
      <p>
        If you are not redirected automatically, please check your connection
        and try again.
      </p>
    </div>
  );
};

export default TokenLoginPage;
